import { render } from "./stockAdjustmentHistoryForm.vue?vue&type=template&id=23bce280&scoped=true"
import script from "./stockAdjustmentHistoryForm.vue?vue&type=script&lang=js"
export * from "./stockAdjustmentHistoryForm.vue?vue&type=script&lang=js"

import "./stockAdjustmentHistoryForm.vue?vue&type=style&index=0&id=23bce280&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23bce280"]])

export default __exports__